(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lezarld-product-details"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
  const button=event.target.closest('[data-quantity-step]');
  if(!button)return;
  const input=button.closest('.product-quantity').querySelector('input[name="quantity"]');
  const minimum=Number(input.min)||1;
  const value=Number(input.value)||minimum;
  input.value=String(Math.max(minimum,value+Number(button.dataset.quantityStep)));
  input.dispatchEvent(new Event('change',{bubbles:true}));
});
document.addEventListener('change',event=>{
  const select=event.target.closest('.product-option');
  if(!select)return;
  const form=select.closest('form');
  const option=select.selectedOptions[0];
  const button=form.querySelector('.product-add');
  const available=option.dataset.available==='true';
  button.disabled=!available;
  button.querySelector('[data-add-label]').textContent=available?button.dataset.availableLabel:button.dataset.soldLabel;
  button.querySelector('[data-add-price]').textContent=option.dataset.price;
  form.closest('.product-purchase').querySelector('.product-price').textContent=option.dataset.price;
});
  } catch(e) { console.error(e); }
})();

})();
